import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Modal,
} from 'react-bootstrap';

import AlertMessage from '../messages/AlertMessage';

class FormModal extends PureComponent {
  render() {
    const {
      show, size, isEditing, title, onHide, children, formId, error,
    } = this.props;
    return (
      <Modal show={show} onHide={onHide} size={size} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error ? (
            <AlertMessage title={error.message} details={error.details} />
          ) : null }
          {children}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" type="button" onClick={onHide}>
            Cancel
          </Button>
          {isEditing ? (
            <Button variant="dark" type="submit" form={formId}>
              Save
            </Button>
          ) : (null) }
        </Modal.Footer>
      </Modal>
    );
  }
}

FormModal.propTypes = {
  show: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isEditing: PropTypes.bool,
  title: PropTypes.string.isRequired,
  onHide: PropTypes.func.isRequired,
  formId: PropTypes.string.isRequired,
  error: PropTypes.instanceOf(Error),
};

FormModal.defaultProps = {
  show: false,
  size: undefined,
  isEditing: true,
  error: undefined,
  children: undefined,
};

export default FormModal;
